import {formatISO, sub} from "date-fns";

// Exact calendar match against the full array rather than a positional offset (e.g. records[i - 12]) - a
// gap in the underlying monthly data would otherwise silently shift a positional lookup onto the wrong month.
export const findExactMonth = <T extends {date: string}>(records: T[], monthsAgo: number, fromDate: Date): T | null => {
    const targetDate = formatISO(sub(fromDate, {months: monthsAgo}), {representation: "date"});

    return records.find((record) => record.date === targetDate) ?? null;
};
import {formatISO, sub} from "date-fns";

// Exact calendar match against the full array rather than a positional offset (e.g. records[i - 12]) - a
// gap in the underlying monthly data would otherwise silently shift a positional lookup onto the wrong month.
export const findExactMonth = <T extends {date: string}>(records: T[], monthsAgo: number, fromDate: Date): T | null => {
    const targetDate = formatISO(sub(fromDate, {months: monthsAgo}), {representation: "date"});

    return records.find((record) => record.date === targetDate) ?? null;
};
